<template>
  <div class="Background">

    <div style="display: flex; justify-content: space-between;">
      <h2 class="Title">
        인코딩 서버 관리
      </h2>

      <div class="link_location">
        설정관리 <v-icon small class="mdi mdi-chevron-right" />
        시스템관리 <v-icon small class="mdi mdi-chevron-right" />
        <a href="/admin/Encoding-Server">인코딩 서버 관리</a>
      </div>

    </div>

    <v-row>
      <v-col cols="5">
        <SearchTextfield :search="searchQuery" placeholder="이름 또는 IP로 서버 찾기" />
      </v-col>

      <v-col class="text-right mb-2">
        <IconButton icon="mdi mdi-autorenew" x-small @click="refresh" class="mr-2" small />
        <TextButton buttonText="활성화" class="mr-2"
          :disabled="selected.length === 0 || selected.some(item => item.is_enabled === 1)"
          @click="encodingServerStatusOnChange" />
        <TextButton buttonText="비활성화" class="mr-2"
          :disabled="selected.length === 0 || selected.some(item => item.is_enabled === 0)"
          @click="encodingServerStatusOffChange" />
        <IconButton icon="mdi-trash-can-outline"
          :disabled="selected.length === 0 || selected.some(item => item.is_enabled === 1)"
          @click="encodingServerDelete" class="mr-2" small />
        <!-- <router-link to="/admin/encodingservers_create"></router-link> -->
        <TextButton icon="mdi-plus" buttonText="서버 추가" isPrimary @click="openModal" />

      </v-col>
    </v-row>

    <v-data-table :headers="headers" :items="encodingServerItem" :items-per-page="10"
      :footer-props="{ itemsPerPageOptions: [10, 20, 30, -1], itemsPerPageText: 'All' }" loading-text="Loading data"
      :key="encodingServerItem.id" :search="searchQuery" :loading="loading" class="data-table elevation-0"
      :disable-sort="true" show-select v-model="selected">

      <template v-slot:item.is_enabled="{ item }">
        <div v-if="item.is_enabled === 1" style="color: #388E3C;">
          <v-icon class="mdi mdi-check-circle-outline mb-1 mr-1" small color="#388E3C"></v-icon><b>Enabled</b>
        </div>
        <div v-else-if="item.is_enabled === 0" style="color: #989898;">
          <v-icon class="mdi mdi-dots-horizontal-circle-outline mb-1 mr-1" small
            color="#989898"></v-icon><b>Disabled</b>
        </div>
      </template>

    </v-data-table>

    <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />

    <AppDialog :value="modalOpen" @input="modalOpen = $event" :persistent="true">
      <template v-slot:title>
        서버 추가
      </template>

      <template v-slot:content>
        <v-row>
          <v-col cols="12" class="mb-2">
            <h4 class="mb-2" style="color:black;">이름</h4>
            <v-form ref="form" v-model="valid" lazy-validation>
              <FormInput v-model="name" :rules="nameRule" ref="nameInput" :counter="10" placeholder="포트" />
            </v-form>
          </v-col>

          <v-col cols="12" class="mb-2">
            <h4 class="mb-2" style="color:black;">아이피</h4>
            <v-form ref="form" v-model="valid" lazy-validation>
              <FormInput v-model="ip" ref="ipInput" placeholder="아이피" />
            </v-form>
          </v-col>

          <v-col cols="12" class="mb-2">
            <h4 class="mb-2" style="color:black;">포트</h4>
            <v-form ref="form" v-model="valid" lazy-validation>
              <FormInput v-model="port" ref="portInput" id="myInput" placeholder="포트" />
            </v-form>
          </v-col>

        </v-row>
      </template>
      <template v-slot:actions>
        <TextButtonBlock buttonText="취소" @click="closeModal" />
        <TextButtonBlock buttonText="등록" @click="addServer" isPrimary />
      </template>
    </AppDialog>

    <!--end-->
  </div>
</template>

<script>
import IconButton from '@/components/ui/button/IconButton.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
// import SearchTextfield from '@/components/ui/form/SearchTextfield.vue';
import SearchTextfield from '@/components/app/AppSearchField.vue';
import EncodingServerApi from "@/api/encodingserver/EncodingServerApi";
import { mapState } from 'vuex';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
import AppDialog from '@/components/app/AppDialog.vue';
import FormInput from '@/components/ui/form/FormInput.vue';



export default {
  components: {
    TextButton,
    IconButton,
    SearchTextfield,
    AppSnackbar,
    AppDialog,
    FormInput,
    TextButtonBlock
  },
  data() {
    return {
      headers: [
        { text: '이름', value: 'name' },
        { text: '아이피', value: 'ip' },
        { text: '생성 날짜', value: 'created_at' },
        { text: '체크', value: 'checked_at' },
        { text: '상태', value: 'is_enabled' },
      ],
      nameRule: [
        v => !!v || 'Name is required',
        v => /^[a-zA-Z][a-zA-Z0-9]*$/.test(v) || 'Must start with a letter and can use letters and numbers',
        v => v && v.length >= 2 && v.length <= 50 || 'Name must be between 2 and 50 characters',
      ],
      ipRule: [
        v => !!v || "IP Address is required",
        v =>
          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
            v
          ) || "IP Address is invalid",
      ],
      portRule: [
        (v) => !!v || "Port is required",
        (v) => /^\d+$/.test(v) || "Port must be a number",
        (v) => v >= 0 && v <= 65535 || "Port must be between 0 and 65535",
      ],
      encodingServerItem: [],
      loading: false,
      search: '',
      selected: [],
      snackbar: false,
      snackbarText: '',
      snackbarError: false,
      snackbarErrorText: '',
      modalOpen: false,
      name: '',
      ip: '',
      port: '',
      valid: true,
    }
  },
  computed: {
    ...mapState('search', ['searchQuery']),
  },
  mounted() {
    this.encodingServerList();
  },
  methods: {
    async closeModal() {
      this.modalOpen = false;
      this.name = '';
      this.ip = '';
      this.port = '';
    },
    async addServer() {
      const data = {
        name: this.name,
        ip: this.ip,
        port: this.port
      }
      const response = await EncodingServerApi.addApi(data);
      if (response.status === 201) {

        this.snackbarText = '생성 성공';
        this.snackbarError = false;
        this.snackbar = true;
        this.closeModal();
        this.encodingServerList();
      } else {
        this.snackbarText = '생성 실패';
        this.snackbarError = true;
        this.snackbar = true;
      }

      setTimeout(() => {
        this.snackbar = false;
        this.snackbarError = false;
      }, 10000);

    },
    async encodingServerList() {
      try {
        this.loading = true;
        const response = await EncodingServerApi.listApi();
        this.loading = false;
        this.encodingServerItem = response.encodingServers;
      } catch (error) {
        console.error('error', error);
      }
    },
    async encodingServerDelete() {

      if (this.selected.length > 0 && !this.selected.some(server => server.is_enabled === 1)) {
        this.loading = true;
        const data = {
          serverIds: this.selected.map(server => server.id)
        };
        try {
          const response = await EncodingServerApi.deleteApi(data);
          if (response.status === 200) {
            this.snackbarText = '삭제 성공';
            this.snackbarError = false;
            this.snackbar = true;
            this.loading = false;
            this.selected = [];
            this.encodingServerList();
          }
        } catch (error) {
          console.error("error", error);
          this.snackbarText = '삭제 실패';
          this.snackbarError = true;
          this.snackbar = true;
        }
      } else {
        console.log('error');
        this.snackbarText = '삭제 실패';
        this.snackbarError = true;
        this.snackbar = true;
      }
    },
    async encodingServerStatusOffChange() {

      if (this.selected.length > 0 && !this.selected.some(server => server.is_enabled === 0)) {
        this.loading = true;

        const data = {
          ids: this.selected.map(server => server.id),
          is_enabled: "0"
        };
        try {
          const response = await EncodingServerApi.statusChangeApi(data);
          if (response.status === 200) {
            this.snackbarText = '변경 성공';
            this.snackbarError = false;
            this.snackbar = true;
            this.loading = false;
            this.selected = [];
            this.encodingServerList();
          } else {
            this.snackbarText = '변경 실패';
            this.snackbarError = true;
            this.snackbar = true;
          }
        } catch (error) {
          console.error("error", error);
        }
      } else {
        console.log('error');
      }

      setTimeout(() => {
        this.snackbar = false;
        this.snackbarError = false;
      }, 10000);

    },
    async encodingServerStatusOnChange() {

      if (this.selected.length > 0 && !this.selected.some(server => server.is_enabled === 1)) {
        this.loading = true;
        const data = {
          ids: this.selected.map(server => server.id),
          is_enabled: "1"
        };
        try {
          const response = await EncodingServerApi.statusChangeApi(data);
          if (response.status === 200) {
            this.snackbarText = '변경 성공';
            this.snackbarError = false;
            this.snackbar = true;
            this.loading = false;
            this.selected = [];
            this.encodingServerList();
          } else {
            this.snackbarText = '변경 실패';
            this.snackbarError = true;
            this.snackbar = true;
          }
        } catch (error) {
          console.error("error", error);
          this.snackbarText = '변경 실패';
          this.snackbarError = true;
          this.snackbar = true;
        }
      } else {
        console.log('error');
        this.snackbarText = '변경 실패';
        this.snackbarError = true;
        this.snackbar = true;
      }

      setTimeout(() => {
        this.snackbar = false;
        this.snackbarError = false;
      }, 10000);
    },
    async refresh() {
      this.encodingServerList();
    },
    openModal() {
      this.modalOpen = true;
    }


  },

}
</script>

<style lang="scss" scoped></style>